<template>
    <div class="ns-sales-forecast-by-location">
        <div class="ns-card mt-6 p-5 flex items-center justify-between">
            <div>
                <h3>Sales forecast by category</h3>
                <div class="my-2">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item><a @click="!category_data_type.store ? getStoreDataAction(true) : ''">Forecast
                                Category</a></el-breadcrumb-item>
                        <el-breadcrumb-item v-if="product_outlet_name" > 
                            <a @click="getStoreWiseSKUData({ outlet: selected_outlet, name: product_outlet_name })">{{ product_outlet_name }}</a>
                        </el-breadcrumb-item>
                        <el-breadcrumb-item v-if="selected_sku_date && !category_data_type.date"> 
                            {{ selected_sku_date }}
                        </el-breadcrumb-item>
                        <!-- <el-breadcrumb-item v-for="(item, index) in breadcrumbs_data" :key="index">
                            <a @click="callBreadCrumbDataAction(item)">{{ item.name }}</a>
                        </el-breadcrumb-item> -->
                    </el-breadcrumb>
                </div>
            </div>

           <div class="flex items-center">

                <el-input v-if="selected_sku_date" v-model="search_product" placeholder="Search by product name" class="mr-6"></el-input>

                <BaseButton v-if="selected_sku_date" :disabled="sfl_table_loading" size="medium" type="submit" style="width: 255px;" buttonclass="btn p-2 text-xs rounded" @click="approveForecastChange()">
                Approve Forecast
                </BaseButton>

                <el-dropdown trigger="click" class="text-xs" @command="downloadAllCsvReports" style="margin-right: 20px; margin-left: 25px;">
                <BaseButton :disabled="sfl_table_loading" size="medium" type="submit" style="width: 155px;" buttonclass="btn p-2 text-xs ">
                Download Reports<i class="pl-2 el-icon-download"></i>
                </BaseButton>
                <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="forecast">Forecast report</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
           </div>
        </div>
        <!-- table section -->
        <!-- Single store table || STore level table -->
        <section v-loading="sfl_table_loading">
            <!-- Store wise consolidated data -->
            <div v-if="category_data_type.store" class="ns-table-section ns-card px-5 py-6">
                <table v-if="!sfl_table_loading && computedAllForecastData.length">
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th colspan="2">Last Year Sales</th>
                            <th colspan="2">Previous Week</th>
                            <th colspan="2">Forecast</th>
                        </tr>
                        <tr>
                            <th>Store Name</th>
                            <th>Sales</th>
                            <th>QTY (BASE UNIT)</th>
                            <th>Sales</th>
                            <th>QTY (BASE UNIT)</th>
                            <th>Sales</th>
                            <th>QTY (BASE UNIT)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in computedAllForecastData" :key="index">
                            <td class="font-semibold cursor-pointer"
                                @click="getStoreWiseSKUData({ outlet: [Object.keys(item)[0]], name: getMappedName(Object.keys(item)[0]) })">
                                <a class="text-sm font-semibold text-amplitude p-2">{{ getMappedName(Object.keys(item)[0])}}</a>
                            </td>
                            <td>{{ item[Object.keys(item)[0]].sales_prev_year }}</td>
                            <td>{{ item[Object.keys(item)[0]].qty_prev_sales }}</td>
                            <td>{{ item[Object.keys(item)[0]].sales_prev }}</td>
                            <td>{{ item[Object.keys(item)[0]].qty_prev }}</td>
                            <td>{{ item[Object.keys(item)[0]].forecast }}</td>
                            <td>{{ item[Object.keys(item)[0]].qty_forecasts }}</td>
                        </tr>
                    </tbody>
                </table>
                <el-empty v-else description="No Data Found!"></el-empty>
            </div>

            <!-- !New Flow -->

            <!-- !New Flow -->

            <!-- Department wise data -->
            <div v-else-if="category_data_type.department" class="ns-table-section ns-card px-5 py-6">
                <div  v-if="!sfl_table_loading && computedDepartmentDateData.length">
                    <table>
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th colspan="2">Last Year Sales</th>
                            <th colspan="2">Previous Week</th>
                            <th colspan="2">Forecast</th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>Sales</th>
                            <th>QTY (BASE UNIT)</th>
                            <th>Sales</th>
                            <th>QTY (BASE UNIT)</th>
                            <th>Sales</th>
                            <th>QTY (BASE UNIT)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in computedDepartmentDateData" :key="index">
                            <td class="font-semibold cursor-pointer"
                                @click="getDeptWiseDateData({ department: [Object.keys(item)[0]], name: getMappedName(Object.keys(item)[0]) })">
                                <a class="text-sm font-semibold text-amplitude p-2">{{ getMappedName(Object.keys(item)[0])}}</a>
                            </td>
                            <td>{{ item[Object.keys(item)[0]].sales_prev_year }}</td>
                            <td>{{ item[Object.keys(item)[0]].qty_prev_sales }}</td>
                            <td>{{ item[Object.keys(item)[0]].sales_prev }}</td>
                            <td>{{ item[Object.keys(item)[0]].qty_prev }}</td>
                            <td>{{ item[Object.keys(item)[0]].forecast }}</td>
                            <td>{{ item[Object.keys(item)[0]].qty_forecasts }}</td>
                        </tr>
                    </tbody>
                </table>
                </div>
                <el-empty v-else description="No Data Found!"></el-empty>
            </div>
            <!-- Department wise data -->
            <!-- Week/Day  wise consolidated product data -->
            <div v-else-if="category_data_type.product" class="ns-table-section ns-card px-5 py-6">

                <p v-if="selected_sku_date" class="mb-4 ml-3 font-semibold">{{ selected_sku_date | formatInto('Do MMMM YYYY, dddd') }}</p>

                <div  v-if="!sfl_table_loading && computedProductData.length">
                    <div class="table-container" style="max-height: 560px; overflow-y: auto;">
                        <table>
                            <thead>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th colspan="2">Last Year Sales</th>
                                    <th colspan="2">Previous Week</th>
                                    <th colspan="2">Forecast</th>
                                </tr>
                                <tr>
                                    <th>Name</th>
                                    <th>Sales</th>
                                    <th>QTY (BASE UNIT)</th>
                                    <th>Sales</th>
                                    <th>QTY (BASE UNIT)</th>
                                    <th>Sales</th>
                                    <th>QTY (BASE UNIT)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in computedProductData" :key="index" :class="item[Object.keys(item)[0]].is_changed ? 'ns-is-edited' : ''">
                                    <td class="font-semibold cursor-pointer" >
                                    {{ item[Object.keys(item)[0]].product_name }}
                                    </td>
                                    <td>{{ item[Object.keys(item)[0]].sales_prev_year }}</td>
                                    <td>{{ item[Object.keys(item)[0]].qty_prev_sales }}</td>
                                    <td>{{ item[Object.keys(item)[0]].sales_prev }}</td>
                                    <td>{{ item[Object.keys(item)[0]].qty_prev }}</td>
                                    <td>{{ item[Object.keys(item)[0]].forecast }}</td>
                                    <!-- <td>{{ item[Object.keys(item)[0]].is_changed ? calculateSales(item, index, item[Object.keys(item)[0]].qty_forecasts) : item[Object.keys(item)[0]].forecast }}</td> -->
                                    <td>
                                        <div class="flex items-center justify-center">
                                            <span>
                                                <el-input-number v-if="item[Object.keys(item)[0]].is_edited" v-model="item[Object.keys(item)[0]].qty_forecasts" :min="0" size="mini" @change="calculateSales(item, index, item[Object.keys(item)[0]].qty_forecasts)"></el-input-number>
                                                <span v-else>{{ item[Object.keys(item)[0]].qty_forecasts }}</span>
                                            </span>
                                            <span>
                                                <img v-if="!item[Object.keys(item)[0]].is_edited" src="../../../assets/icons/edit-icon.svg" alt="edit" class="cursor-pointer ml-3 font-semibold text-amplitude" width="13px" @click="item[Object.keys(item)[0]].is_edited = true, $forceUpdate()">
                                                <i v-if="item[Object.keys(item)[0]].is_edited" class="el-icon-circle-check mx-1 ml-4 text-xl cursor-pointer font-semibold text-amplitude" @click="item[Object.keys(item)[0]].is_edited = false, item[Object.keys(item)[0]].is_changed = true, changedDate(item)"></i>
                                                <i v-if="item[Object.keys(item)[0]].is_edited" class="el-icon-circle-close mx-1 text-xl cursor-pointer font-semibold text-amplitude" @click="item[Object.keys(item)[0]].is_edited = false, item[Object.keys(item)[0]].is_changed = false, getOriginalData(item, index)"></i>
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                    </table>
                    </div>
                </div>
                <el-empty v-else description="No Data Found!"></el-empty>
                 <!-- Pagination -->
                 <!-- <div class="w-full block mt-3 py-5">
                    <el-pagination
                        :current-page.sync="currentPage1"
                        :page-sizes="[5, 10, 15, 20, 25, 30, 35, 40]"
                        :page-size="currentSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        style="float: right;"
                        :total="product_col_data.count"
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange">
                    </el-pagination>
                </div> -->
                <!-- Pagination -->
            </div>
            <!-- Date wise product data -->
            <div v-else-if="category_data_type.date" class="ns-table-section ns-card px-5 py-6">
                <table v-if="!sfl_table_loading && computedProductDateData.results.length">
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th colspan="2">Last Year Sales</th>
                            <th colspan="2">Previous Week</th>
                            <th colspan="2">Forecast</th>
                            <!-- <th v-if="aggregate==='day'" >&nbsp;</th> -->
                        </tr>
                        <tr>
                            <th>Date</th>
                            <th>Sales</th>
                            <th>QTY (BASE UNIT)</th>
                            <th>Sales</th>
                            <th>QTY (BASE UNIT)</th>
                            <th>Sales</th>
                            <th>QTY (BASE UNIT)</th>
                            <!-- <th v-if="aggregate==='day'" >Approve Forecast</th> -->
                        </tr>
                    </thead>
                    <tbody>
                            <tr v-for="(item, index) in computedProductDateData.results" :key="index">
                                <td  class="font-semibold cursor-pointer"
                                    @click="getSKUDateData({ date: [Object.keys(item)[0]], name:'' })">
                                    <a class="text-sm font-semibold text-amplitude p-2">{{ Object.keys(item)[0] | formatInto('Do MMMM YYYY, dddd')}}</a>
                                </td>
                                <td>{{ item[Object.keys(item)[0]].sales_prev_year }}</td>
                                <td>{{ item[Object.keys(item)[0]].qty_prev_sales }}</td>
                                <td>{{ item[Object.keys(item)[0]].sales_prev }}</td>
                                <td>{{ item[Object.keys(item)[0]].qty_prev }}</td>
                                <td>{{ item[Object.keys(item)[0]].forecast }}</td>
                                <td>{{ item[Object.keys(item)[0]].qty_forecasts }}</td>
                                <!-- <td class="ns-sfl-btn">
                                    <el-button v-if="aggregate==='day'" :class="!item[Object.keys(item)[0]].approved ? 'ns-button' : ''" :type="item[Object.keys(item)[0]].approved ? 'success' : ''"
                                        @click="approveForecast(Object.keys(item)[0])">{{item[Object.keys(item)[0]].approved ? 'Approved' : 'Approve'}}</el-button>
                                </td> -->
                            </tr>
                    </tbody>
                </table>
                <el-empty v-else description="No Data Found!"></el-empty>
            </div>
        </section>

        <!-- Dialog -->
        <div v-if="approve_forecast_dialog">
            <el-dialog v-loading="forecast_popup_loading"
                :title="'Approve Forecast - ' + selected_store_level + ` (${formattedDate})`"
                :visible.sync="approve_forecast_dialog" fullscreen custom-class="ns-dialog">
                <ApproveForecast :selected-store="selected_store_id" :formatted-day="formattedDay" :all-events="store_events" :event-categories="event_categories" :is-data-loaded="forecast_popup_loaded" :selected-date="formattedDate"
                    :forecast-data="forecast_approve_data" @updateAdjTrx="updateAdjTrx"/>
                <!-- Graph -->
                <DayForecastGraph class="mb-8" :is-data-loaded="forecast_popup_loaded" :graph-data="forecast_graph_data" />
                <span slot="footer" class="dialog-footer">
                    <el-button class="ns-light-button" @click="approve_forecast_dialog = false">Cancel</el-button>
                    <el-button class="ns-button" :style="checkIsApproved ? 'cursor: not-allowed;' : 'cursor:pointer;'" @click="checkIsApproved ? '' : callApproveForecast()">{{ checkIsApproved ? 'Approved' : 'Approve'}}</el-button>
                    <!-- <a @click="callUnApproveForecast">Undo</a> -->
                </span>
            </el-dialog>
        </div>
        <!-- Dialog -->

    </div>
</template>

<script>
import ApproveForecast from "../dialogs/ApproveForecast.vue";
import DayForecastGraph from "../graphs/DayForecastGraph.vue";
import { mapState, mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { EventBus } from "../../../eventBus.js";
import forecast_api from "../../../services/forecastService.js";
import {serverAddrForCSV} from "../../../networkConfig";

export default {
    name: "SalesForecastByCategory",
    components: {
        ApproveForecast,
        DayForecastGraph
    },
    props: {

    },
    data() {
        return {
            approve_forecast_dialog: false,
            currentPage1: 1,
            currentSize1: 10,
            adjusted_trx: 0,
            select_all_approve: false,
            approve_loading: false,
            approved_selected: true,
            changed_data: [],
            search_product: ''
        }
    },
    computed: {
        ...mapState("SalesForecastStore", [
            "all_forecast_data",
            "col_forecast_data",
            "sfl_table_loading",
            "is_store_level_table",
            "store_forecast_data",
            "selected_store_level",
            "set_selected_approve_date",
            "forecast_approve_data",
            "forecast_graph_data",
            "forecast_popup_loading",
            "forecast_popup_loaded",
            "store_events",
            "event_categories",
            "selected_store_id",
            "aggregate",
            "basics",
            "category_data_type",
            "product_col_data",
            "product_outlet_name",
            "product_date_col_data",
            "department_col_data",
            "breadcrumbs_data",
            "selected_outlet",
            "selected_sku_date",
            "filter_data",
            "selected_dates",
        ]),
        ...mapGetters("SalesForecastStore", ["getMappedName"]),
        computedAllForecastData() {
            let arr = [];
            if (this.all_forecast_data.results) {
                arr = this.all_forecast_data.results;
            }
            return arr;
        },
        computedProductData() {
            let arr = [];
            if (this.product_col_data.length) {
                arr = JSON.parse(JSON.stringify(this.product_col_data));
                for (let e of arr) {
                    e[Object.keys(e)[0]].product_name = this.getMappedName(Object.keys(e)[0]);
                }
            }
            const searchTerm = this.search_product.toLowerCase();
            if(searchTerm) {
                arr = arr.filter(product => {
                    return product[Object.keys(product)[0]].product_name.toLowerCase().includes(searchTerm);
                });
            }
            return arr;
        },
        computedProductDateData() {
            let arr = [];
            if (this.product_date_col_data) {
                arr = this.product_date_col_data;
            }
            return arr;
        },
        computedDepartmentDateData() {
            let arr = [];
            if (this.department_col_data.results.length) {
                arr = this.department_col_data.results;
            }
            return arr;
        },
        computedStoreForecastData() {
            return this.store_forecast_data.results;
        },
        computedColForecastData() {
            return this.col_forecast_data;
        },
        formattedDate() {
            return moment(this.set_selected_approve_date, 'YYYY-MM-DD').format('Do MMMM YYYY, dddd');
        },
        formattedDay() {
            return moment(this.set_selected_approve_date, 'YYYY-MM-DD').format('dddd');
        },
        checkIsApproved(){
            let condition = 0;
            if(this.set_selected_approve_date){
                let selected_data = this.computedProductDateData.find((i)=>i[this.set_selected_approve_date]);
                condition =  selected_data[this.set_selected_approve_date].approved;
            }
            return condition;
        }
    },
    // eslint-disable-next-line vue/order-in-components
    filters: {
        formatInto(value, format) {
            return moment(value).format(format);
        },
        formatDateInto(value, format) {
            return moment(value,'YYYY-MM-DD').format(format);
        },
    },
    created(){
        this.getStoreDataAction(true);
    },
    methods: {
        ...mapActions("SalesForecastStore", ["loadStoreDataAction", 
            "getStoreDataAction", 
            "loadApproveForecastData", 
            "loadDateWiseForecastData", 
            "loadBasicsWiseCategoryData",
            "getStoreWiseProductData",
            "getProductWiseDateData",
            "getProductWiseWeekData",
            "getDeptWiseDateData",
            "callPaginatedApi",
            "getStoreWiseSKUData",
            "getSKUDateData",
            "callSKUPaginatedApi",
        ]),
        ...mapActions("CommonStore",["addDownloadingReportCountAction", "removeDownloadingReportCountAction", "abortDownloadingReportCountAction"]),
        handleSizeChange(val) {
            this.currentSize1 = val;
            console.log(`${val} items per page`);
            this.callSKUPaginatedApi({size:this.currentSize1, page: this.currentPage1});
        },
        getOriginalData(item, index){
            this.computedProductData[index][Object.keys(item)[0]].qty_forecasts = this.product_col_data[index][Object.keys(item)[0]].qty_forecasts;
            this.computedProductData[index][Object.keys(item)[0]].forecast = this.product_col_data[index][Object.keys(item)[0]].forecast;
            this.$forceUpdate();
        },
        calculateSales(item, index, forecast){
            // Calculate sales using old data
            if(parseInt(forecast)){
                const value_per_item = this.product_col_data[index][Object.keys(item)[0]].forecast / this.product_col_data[index][Object.keys(item)[0]].qty_forecasts;
                const original_value = this.product_col_data[index][Object.keys(item)[0]].forecast;
                const original_qty = this.product_col_data[index][Object.keys(item)[0]].qty_forecasts;

                // console.log(value_per_item, original_value, forecast, original_qty,  'value_per_item');

                this.computedProductData[index][Object.keys(item)[0]].forecast = forecast * value_per_item;
            }

            if(parseInt(forecast) === 0){
                this.computedProductData[index][Object.keys(item)[0]].forecast = 0;
            }

            this.$forceUpdate();
        },
        handleCurrentChange(val) {
            this.currentPage1 = val;
            console.log(`current page: ${val}`);
            this.callSKUPaginatedApi({size:this.currentSize1, page: this.currentPage1});
        },
        approveForecast(date) {
            this.$store.commit("SalesForecastStore/SET_SELECTED_APPROVE_DAT", date)
            this.loadApproveForecastData();
            // this.$store.commit('SalesForecastStore/SET_FORECAST_APPROVE_GRAPH_DATA')
            // EventBus.$emit("renderDayForecastGraph")
            this.approve_forecast_dialog = true;
            // setTimeout(()=>{
            // }, 1500)
        },
        checkSelectedRecords(event){
            return this.computedStoreForecastData.some((e)=>e.is_selected)
        },
        handleSelectAll(event){
            this.computedStoreForecastData.map((e)=>{
                if(event && !e.approved){
                    e.is_selected = event;
                }else{
                    e.is_selected = event;
                }
            });
        },
        handleSingleSelect() {
            if(this.computedStoreForecastData.every((e)=> !e.is_selected && !e.approved)){
                this.select_all_approve = false;
            }
            this.$forceUpdate();
        },
        callApproveForecast() {
            this.approve_loading = true;
            let payload = {
                "date": this.set_selected_approve_date,
                "old_forecast": this.forecast_approve_data.forecast.sales,
                "new_forecast": this.adjusted_trx,
                "approve": true,
                "outlet": this.selected_store_id
            };
            forecast_api.approveForecast(payload).then((res)=>{
                this.loadStoreDataAction({ outlet: [this.selected_store_id], name: this.selected_store_level });
                this.loadApproveForecastData();
                this.approve_forecast_dialog = false;
                this.approve_loading = false;
            }).catch((err)=>{
                console.error(err);
                this.approve_loading = false;
            });
        },
        approveSelected() {
            var adjustedVal = 0;
            this.performSelectedApprove();
        },
        approveForecastChange() {
            // Prepare Payload
            let payload = {
                outlet: this.selected_outlet[0],
                date: this.selected_sku_date,
                products: {}
            }

            let converted_data = {};
            this.changed_data.forEach(item => {
                const key = Object.keys(item)[0];
                // Get the qty_forecasts value for this object
                const qty_forecasts = item[key].qty_forecasts;
                // Add it to the converted_data object
                converted_data[key] = qty_forecasts;
            });

            payload.products = converted_data;

            console.log(payload, 'payload');
            // this.this.changed_data;
            this.$confirm(`${'Approving forecast for ' + moment(this.selected_sku_date, 'YYYY-MM-DD').format(('Do MMMM YYYY')) + ', do you wish to continue?'}`, 'Approve Forecast', {
                confirmButtonText: 'Approve',
                cancelButtonText: 'Cancel',
                // type: 'warning',
                customClass: 'ns-confirm-box'
            }).then(() => {
                forecast_api.approveChangedForecast(payload).then((res)=>{
                    // this.loadStoreDataAction({ outlet: [this.selected_store_id], name: this.selected_store_level });
                    this.getSKUDateData({ date: [this.selected_sku_date], name:'' });
                    this.loadApproveForecastData();
                    this.approve_forecast_dialog = false;
                    this.approve_loading = false;
                }).catch((err)=>{
                    console.error(err);
                    this.approve_loading = false;
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Approve canceled'
                });
            });
        },
        changedDate(item){
            this.changed_data.push(item);
            this.$forceUpdate();
        },
        performSelectedApprove(){
            this.approve_loading = true;
            this.computedStoreForecastData.map((e)=>{
                if(e.is_selected && !Object.values(e)[0].approved){
                    console.log(Object.keys(e),Object.values(e), 'selected')
                    let payload = {
                        "date": Object.keys(e)[0],
                        "old_forecast": Object.values(e)[0].trans_forecasts,
                        "new_forecast": Object.values(e)[0].adjusted_quantity,
                        "approve": true,
                        "outlet": this.selected_store_id
                    };
                    forecast_api.approveForecast(payload).then((res)=>{
                        this.loadStoreDataAction({ outlet: [this.selected_store_id], name: this.selected_store_level });
                        this.loadApproveForecastData();
                        this.approve_forecast_dialog = false;
                        this.approve_loading = false;
                    }).catch((err)=>{
                        console.error(err);
                        this.approve_loading = false;
                    });
                }
            });
        },
        callUnApproveForecast() {
            let payload = {
                "date": this.set_selected_approve_date,
                "old_forecast": this.forecast_approve_data.forecast.sales,
                "new_forecast": this.adjusted_trx,
                "approve": false,
                "outlet": this.selected_store_id
            };
            forecast_api.approveForecast(payload).then((res)=>{
                this.loadStoreDataAction({ outlet: [this.selected_store_id], name: this.selected_store_level });
                this.loadApproveForecastData();
                this.approve_forecast_dialog = false;
            }).catch((err)=>{
                console.error(err);
            });
        },
        updateAdjTrx(value) {
            this.adjusted_trx = value;
        },
        handleClose() {

        },
        downloadAllCsvReports(cmd) {
            if(cmd === 'forecast') {
                this.downloadCsvReport();
            }
        },
        downloadCsvReport(extension) {
            this.is_csv_loading = true;   //displayed loader on button
            this.addDownloadingReportCountAction();
            let startDate = '';
            let endDate = '';
            if(this.filter_data.aggregate === 'day') {
                startDate = this.selected_dates.from_date
                endDate = this.selected_dates.to_date
            } else if(this.filter_data.aggregate === 'week') {
                var dt = new Date(moment(this.filter_data.start_date, 'YYYY-MM-DD')); // current date of week
                var currentWeekDay = dt.getDay();
                var lessDays = currentWeekDay === 0 ? 6 : currentWeekDay - 1;
                var wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));

                let wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));

                startDate = moment(wkStart).format("YYYY-MM-DD");
                endDate = moment(wkEnd).format("YYYY-MM-DD");
            }

            if(this.selected_sku_date && !this.category_data_type.date) {
                startDate = this.selected_sku_date;
                endDate = this.selected_sku_date;
            }

            if(!startDate && !endDate) {
                this.$notify.error({
                    title: "Oops",
                    message: "Something went wrong!"
                });
                return true;
            }

            var params = {
                start_date: startDate,
                end_date: endDate,
                outlets: this.product_outlet_name ? (this.selected_store_id ? [this.selected_store_id] : this.selected_outlet ? this.selected_outlet : []) : this.filter_data.location.length ? this.filter_data.location : [],
                type: this.filter_data.type
            };
            const reportName = this.filter_data.type === 'r_material' ? 'Raw Material' : this.filter_data.type;
            serverAddrForCSV
                .post(`/forecast/download-forecast-csv/`, params)
                .then(response => {
                if (response.status == 200) {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", `${'ForecastReport-' + reportName + '-' +params.start_date+'/'+params.end_date+'.csv'}`);
                    document.body.appendChild(fileLink);

                    fileLink.click();
                }
                this.removeDownloadingReportCountAction();
                this.is_csv_loading = false;   //hide loader on button
                })
                .catch(err => {
                console.log(err);
                this.is_csv_loading = false;   //hide loader on button
                this.abortDownloadingReportCountAction();
                    this.$notify.error({
                        title: "Error",
                        message: "Something went wrong!"
                    });
                });
        }
    },
}
</script>

<style lang="scss" scoped>
.ns-table-section {
    table {
        width: 100%;
        text-align: center;
        border-collapse: separate;
        border-spacing: 0;
        td {
            // border-radius: 8px !important;
            font-size: 14px;
            color: #111;
            padding: 10px 5px;
            border: 1px solid #E2E5EA;
            text-transform: capitalize;
        }
        th{
            font-size: 14px;
            color: #111;
            padding: 10px 5px;
            border: 1px solid #E2E5EA;
            text-transform: capitalize;
            background: #f2f2f2;
            color: #111;
        }
        thead tr:first-child th:first-child {
            border-top-left-radius: 8px;
        }
        thead tr:first-child th:last-child {
            border-top-right-radius: 8px;
        }

        tbody tr:last-child td:first-child {
            border-bottom-left-radius: 8px;
        }

        tbody tr:last-child td:last-child {
            border-bottom-right-radius: 8px;
        }
        
    }
}

.ns-sfl-btn {
    button {
        margin: 0 auto;
    }
}
</style>

<style>
.el-pager li.active {
    color: #e29d5a;
    cursor: default;
}
.el-pager li:hover {
    color: #e29d5a;
}
.el-pagination button:hover {
    color: #e29d5a;
}
.el-select-dropdown__item.selected {
    color: #e29d5a;
    font-weight: 700;
}
.ns-sales-forecast-by-location .el-breadcrumb {
    text-transform: capitalize;
}

.ns-button.el-button {
    color: #fff;
    background-color: #e29d5a;
    border-color: #e29d5a;
}

.ns-button.el-button:hover {
    background: #e9a765;
    border-color: #e9a765;
    color: #fff;
}

.ns-sales-forecast-by-location .el-breadcrumb__inner a:hover,
.el-breadcrumb__inner.is-link:hover {
    color: #e29d5a;
    cursor: pointer;
}

.ns-dialog .el-dialog__header {
    background: #fdfdfd;
    color: #1c1b1b;
    padding: 25px 20px;
    border-radius: 8px;
}

.ns-dialog.el-dialog {
    border-radius: 8px;
}

.ns-dialog .el-dialog__title {
    text-transform: capitalize;
    color: #1c1b1b;
    font-weight: 600;
}

.ns-dialog .el-dialog__footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 15px 35px;
    background: #fff;
}
.ns-dialog .el-dialog__body {
    padding: 5px 20px 30px 20px !important;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
.ns-sales-forecast-by-location .el-dialog__wrapper{
    background: #00000094 !important;
}
/* .ns-sales-forecast-by-location .el-dialog__wrapper{
    height: 100%;
    overflow: hidden;
} */
.ns-table{
    min-height: 650px;
}
.ns-is-edited{
    background: #f8e6d4;
}
</style>